import React from "react";
import { ArcStack, ArcText } from "@src/core/ui";
import { arcDateWithTime } from "@src/core/extensions";
import { ArcInFlightCardDetailsProps } from "./types";

const ArcInFlightCardDetails: React.FC<ArcInFlightCardDetailsProps> = ({
  order,
  drone,
}) => {
  const getOrderData = () => {
    const orderData = order as any;
    if (orderData?.orders && orderData?.orders?.length > 0) {    
      return {
        id: orderData.orders[0].id,
        missionId: orderData.missionId,
        createDate: orderData.orders[0].createDate,
        deliveryLocation: orderData.orders[0].deliveryLocation,
        clientName: orderData.orders[0].clientName,
        status: orderData.orders[0].status,
      };
    }
    return null;
  };

  const orderData = getOrderData();
  const droneName = order?.drone?.name || drone?.name;
  
  return (
    <ArcStack direction="column">
      <ArcText color="text.secondary" fontSize={12}>
        {orderData ? arcDateWithTime(orderData.createDate) : "N/A"}
      </ArcText>
      <ArcStack>
        <ArcText.h6 color="white" fontSize={12} fontWeight={600} mt={"8px"}>
          {orderData ? `#${orderData.id || orderData.missionId?.slice(0, 8) + "..." || "N/A"}` : "N/A"}
        </ArcText.h6>
      </ArcStack>
      <ArcText
        color="text.secondary"
        fontSize={12}
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          marginTop: "4px",
        }}
      >
        {orderData?.deliveryLocation?.address || "N/A"}
      </ArcText>
      <ArcStack bgcolor={'blue.main'} marginTop={'8px'} borderRadius={5} padding={'4px 9px' } width={'fit-content'}>  
        <ArcText color="white" fontSize={10} >
          {droneName || "N/A"}
        </ArcText>
      </ArcStack>
    </ArcStack>
  );
};

export default ArcInFlightCardDetails;
